"use client"

import { Button } from "@/components/ui/button"
import { ExternalLink, ShoppingCart } from "lucide-react"

interface BuyButtonsProps {
  bookTitle: string
  author: string
  className?: string
  size?: "sm" | "default" | "lg"
  variant?: "default" | "outline" | "secondary"
}

export function BuyButtons({ 
  bookTitle, 
  author, 
  className = "", 
  size = "default",
  variant = "outline"
}: BuyButtonsProps) {
  
  // Create search query for the book
  const searchQuery = encodeURIComponent(`${bookTitle} ${author}`)
  
  // Amazon affiliate links (replace with your actual affiliate ID)
  const amazonUrl = `https://www.amazon.in/s?k=${searchQuery}&tag=booksip-21`
  
  // Flipkart affiliate links (replace with your actual affiliate ID)
  const flipkartUrl = `https://www.flipkart.com/search?q=${searchQuery}&affid=booksip`

  const handleBuyClick = (url: string, platform: string) => {
    // Track affiliate clicks (you can add analytics here)
    console.log(`Affiliate click: ${platform} for "${bookTitle}"`)
    
    // Open in new tab
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={`flex gap-2 ${className}`}>
      <Button
        onClick={() => handleBuyClick(amazonUrl, 'Amazon')}
        variant={variant}
        size={size}
        className="flex-1 bg-orange-50 hover:bg-orange-100 text-orange-700 border-orange-200 hover:border-orange-300"
      >
        <ShoppingCart className="h-3 w-3 mr-1" />
        Amazon
        <ExternalLink className="h-2 w-2 ml-1" />
      </Button>
      
      <Button
        onClick={() => handleBuyClick(flipkartUrl, 'Flipkart')}
        variant={variant}
        size={size}
        className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300"
      >
        <ShoppingCart className="h-3 w-3 mr-1" />
        Flipkart
        <ExternalLink className="h-2 w-2 ml-1" />
      </Button>
    </div>
  )
}

// Compact version for smaller spaces
export function CompactBuyButtons({ 
  bookTitle, 
  author, 
  className = ""
}: Omit<BuyButtonsProps, 'size' | 'variant'>) {
  
  const searchQuery = encodeURIComponent(`${bookTitle} ${author}`)
  const amazonUrl = `https://www.amazon.in/s?k=${searchQuery}&tag=booksip-21`
  const flipkartUrl = `https://www.flipkart.com/search?q=${searchQuery}&affid=booksip`

  const handleBuyClick = (url: string, platform: string) => {
    console.log(`Affiliate click: ${platform} for "${bookTitle}"`)
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={`flex gap-1 ${className}`}>
      <Button
        onClick={() => handleBuyClick(amazonUrl, 'Amazon')}
        variant="outline"
        size="sm"
        className="flex-1 bg-orange-50/50 hover:bg-orange-100/70 text-orange-600 border-orange-200 hover:border-orange-300 text-xs"
      >
        <ShoppingCart className="h-2 w-2 mr-1" />
        Amazon
        <ExternalLink className="h-2 w-2 ml-1" />
      </Button>
      
      <Button
        onClick={() => handleBuyClick(flipkartUrl, 'Flipkart')}
        variant="outline"
        size="sm"
        className="flex-1 bg-blue-50/50 hover:bg-blue-100/70 text-blue-600 border-blue-200 hover:border-blue-300 text-xs"
      >
        <ShoppingCart className="h-2 w-2 mr-1" />
        Flipkart
        <ExternalLink className="h-2 w-2 ml-1" />
      </Button>
    </div>
  )
}
